export default {
  translateLangCheck: {
    title: "Проверка литеральных констант",
    close: "Закрыть",
    checking: "Выполняется проверка литеральных констант…",
    requestError: "Ошибка выполнения запроса",
    noViolations: "Нарушений не найдено.",
    noLanguageTag: "(без тега)",
    columns: {
      subject: "Субъект",
      predicate: "Предикат",
      language: "Язык",
      count: "Количество",
      violation: "Нарушение"
    }
  },
  uriReplacement: {
    title: "Замена URI",
    cancel: "Отмена",
    replace: "Заменить",
    sourceUri: "Исходный URI",
    targetUri: "Целевой URI",
    invalidSourceUri: "Исходный URI имеет неверный формат.",
    invalidTargetUri: "Целевой URI имеет неверный формат.",
    urisMustDiffer: "Исходный и целевой URI должны отличаться.",
    positions: "Заменить URI в позициях:",
    subjects: "Субъекты ({{count}})",
    predicates: "Предикаты ({{count}})",
    objects: "Объекты ({{count}})",
    checkingUsage: "Проверка использования URI…",
    backupWarning: "Перед заменой URI рекомендуется заархивировать данные.",
    error: "Ошибка",
    success: "Замена URI выполнена."
  },
  conceptUriReplacement: {
    title: "Замена URI концепта",
    inScheme: "Связанные со схемой",
    notInScheme: "Не связанные со схемой",
    sourceMode: "Способ задания исходного URI",
    selectConcept: "Выбрать концепт",
    enterManually: "Задать вручную",
    concept: "Концепт",
    selectSourceUri: "Выберите исходный URI",
    loadError: "Не удалось загрузить список концептов"
  }
}
